import { createFileRoute, redirect } from '@tanstack/react-router';

import { isPersonExecutive } from 'helpers/person';

export const Route = createFileRoute('/_private/_route')({
  beforeLoad: async ({ context }) => {
    // Team onboarding /signup invites colleagues to the person's team, so it
    // needs a team role. Executives and people on no team have none.
    if (isPersonExecutive(context.user) || !context.role?.team_slug) {
      return;
    }

    // @ts-ignore
    const metadata = window.Clerk?.user?.publicMetadata || {};

    if (
      'onboarding_complete' in metadata &&
      metadata.onboarding_complete === false
    ) {
      throw redirect({ replace: true, to: '/signup' });
    }
  },
});
